export const Technology = () => {
    return (
        <section className="technology section" id="technology">
            <div className="container">
                <div className="section__header">
                    <span className="section__badge">Technology</span>
                    <h2 className="section__title">Proprietary Market Analytical Engine</h2>
                    <p className="section__description">
                        MAM’s multi-agent ecosystem synthesizes diverse market data and rigorously debates every scenario to eliminate bias and expand your perspective.
                    </p>
                </div>
                
                <div className="technology__visual">
                    <img 
                        src="/assets/model_architecture.png" 
                        alt="MAM Underlying Model Architecture showing the multi-agent ecosystem" 
                        loading="lazy"
                        className="technology-image"
                    />
                </div>
            </div>
        </section>
    );
};
